<template>
  <div id="bookmarks-index" class="row container row-v2">
    <div class="col">
      <div class="col__box">
        <template v-if="bookmarks.data && bookmarks.data.size != 0">
          <div v-for="bookmark in bookmarks.data" :key="bookmark.slug">
            <episode-item-horizontal-component :episode="bookmark"/>
          </div>
        </template>
        <template v-else>
          <div class="alert alert-warning">
            <strong>Empty Bookmarks!</strong> No Bookmarks is here.
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'bookmarks-index',
  data() {
    return {
      bookmarks: {
        data: [],
      }
    }
  },
  methods: {
    async load() {
      this.bookmarks = await window.api.bookmarks.get();
    }
  },
  created() {
    this.load();
  },
  watch: {
    $route() {
      this.load();
    }
  },
  metaInfo() {
    return {
      title: this.$t('Bookmarks'),
    }
  },
}

</script>
